module.exports = __webpack_public_path__ + "img/ai-avatar.85e4a8f3.png";